import React from 'react';
import ButtonComponent from '../button-component/button-component';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import styles from './Modal.module.css';

interface ModalCommonButtonsContainerInterface {
  submitButtonText: string | React.ReactNode;
  cancelButtonText?: string | React.ReactNode;
  onClose: () => void;
  onSave: () => void;
  loading?: boolean;
  disabled?: boolean;
  fontSize?: string | number;
  buttonStyle?: React.CSSProperties;
  className?: string;
  style?: React.CSSProperties;
  disabledTooltipText?: string;
  secondaryButtonClassName?: string;
  showSecondaryButton?: boolean;
  primaryButtonClassName?: string;
  tooltipStyle?: React.CSSProperties;
}

export default function ModalCommonButtonsContainer({
  submitButtonText,
  cancelButtonText = 'Cancel',
  onClose,
  onSave,
  loading = false,
  disabled = false,
  fontSize = '16px',
  buttonStyle,
  className,
  style,
  disabledTooltipText = '',
  secondaryButtonClassName = '',
  showSecondaryButton = true,
  primaryButtonClassName = '',
  tooltipStyle = {},
}: ModalCommonButtonsContainerInterface) {
  return (
    <div className={`${styles.modalCommonButtonsContainer} ${className}`} style={style}>
      {showSecondaryButton && (
        <ButtonComponent
          textStyle={{ fontSize }}
          style={buttonStyle}
          className={secondaryButtonClassName}
          variant="secondary"
          onClick={onClose}
          fullWidth
        >
          {cancelButtonText}
        </ButtonComponent>
      )}
      <CustomTooltip
        show={
          disabled && Boolean(disabledTooltipText) && Boolean(disabledTooltipText && disabledTooltipText?.length > 0)
        }
        title={disabledTooltipText}
        style={tooltipStyle}
      >
        <ButtonComponent
          textStyle={{ fontSize }}
          style={buttonStyle}
          disabledStyle={{ fontSize }}
          showLoading={loading}
          disabled={disabled}
          className={primaryButtonClassName}
          fullWidth
          onClick={() => {
            onSave();
          }}
        >
          {submitButtonText}
        </ButtonComponent>
      </CustomTooltip>
    </div>
  );
}
